import { useContext, useEffect, useState } from "react";
import CustomButton from "../../components/CustomMiscellaneous/CustomButton";
import { genericGet } from "../../services/api.service";
import UsbOffIcon from '@mui/icons-material/UsbOff';
import UsbIcon from '@mui/icons-material/Usb';
import toast from "react-hot-toast";
import { FactoryFloorContext } from "../../contexts/FactoryFloorContext";

const decoder = new TextDecoder();


const Postos = [
    'CNC',
    'Projeto',
    'Serrote',
    'Convencionais',
    
    'Acabamento',
    'Tratamento',
    'Controlo e Qualidade',
    'Expedição',
]; 


export default function QRCodePicker({  setScannerConnected }: any) {

    const [device, setDevice] = useState<any>(null);

    const [result, setResult] = useState<string | null>(null);

    const {selectionValues, setSelectionValues} = useContext(FactoryFloorContext);

    const pecaScanned = selectionValues.obra && selectionValues.entrega && selectionValues.operacao;


    useEffect(()=> {
            console.log("Selection values updated!!");
    }, [selectionValues])


    const buildForm = async ({ obraId, entregaId, pecaEntregaId, operacao }: { obraId: string | null, entregaId: string | null, pecaEntregaId: string | null, operacao: string | null }) => {
        const obra = await genericGet(`/obras/${obraId}`);

        const entrega = await genericGet(`/obras/${obraId}/entregas/${entregaId}`);

        const pecaEntrega = await genericGet(`/obras/${obraId}/entregas/${entregaId}/pecas-entrega/${pecaEntregaId}`);

        setSelectionValues({
            'obra': obra,
            'entrega': entrega,
            'operacao': operacao,
            'pecaEntrega': pecaEntrega
        });
    }


    useEffect(() => {
        console.log("-------------> QRCode info: ", result);
        const splittedQRCode = result?.split('-');
        const obraId = splittedQRCode ? splittedQRCode[0] : null;
        const entregaId = splittedQRCode ? splittedQRCode[1] : null;
        const pecaEntregaId = splittedQRCode ? splittedQRCode[2] : null;
        const operacao = splittedQRCode ? splittedQRCode[3].trim() : null;
        buildForm({ obraId, entregaId, pecaEntregaId, operacao })
    }, [result])


    const connectUsbDevice = async () => {

        try {
            const device = await (navigator as any).usb.requestDevice({
                filters: [{
                    vendorId: 0x067b
                }]
            })

            await device.open();
            await device.selectConfiguration(1);
            await device.claimInterface(0);
            setDevice(device);
            toast.success('Dispositivo conectado com sucesso!!!!');

            while (true) {
                const resp = await device.transferIn(3, 64);
                setResult(decoder.decode(resp.data))
            }


        } catch (e) {
            console.log("error: ", e);
            toast.error('Erro ao conectar dispositivo!');
        }

    }


    const disconnectUsbDevice = () => {
        try {
            if (device)
             device.close();
            toast.success('Dispositivo disconectado com sucesso!');
            setDevice(null);
        } catch (e) {
            toast.error('Erro ao disconectar dispositivo');
        }
    }


    useEffect(()=>()=>disconnectUsbDevice(),[])

    useEffect(()=>{
        setScannerConnected(!!device);
    }, [device])

    return (<div className="w-1/2 p-3 ml-10 mb-4 border rounded-md shadow-md">
        {device ?
            <>
                <div className="w-full flex items-center justify-between">
                    <div className="flex itemc-center">
                        <UsbIcon className="text-lime-500 mr-5" />
                        <div className="font-bold">Scanner operacional</div>
                    </div>
                    <CustomButton text={"Desconectar"} onClick={disconnectUsbDevice} />
                </div>
            </>

            :
            <div className="w-full flex items-center ">

                <UsbOffIcon className="mr-5 text-amber-700" />

                <CustomButton onClick={connectUsbDevice} text={"Conectar scanner"} />


            </div>

        }

        {(!device || !pecaScanned) ? null :
            <div className="mt-4">
                <div>
                    <span className="font-bold">Obra seleccionada:</span> {selectionValues?.obra?.number} ({selectionValues?.obra?.client?.name})
                </div>
                <div>
                    <span className="font-bold">Entrega seleccionada:</span> {selectionValues?.entrega?.publicDeliveryDate?.toString().split('T')[0]}
                </div>
                <div>
                    <span className="font-bold">Operação seleccionada:</span> {selectionValues?.operacao}
                </div>
            </div>}



    </div>)


}